import { METRICS_MAP } from '@intelligence/v3/pages/CasualGenreProfile/constants';

/**
 * @description MetricSegment 常量配置
 */

import type { TMetricType } from '../../types';
import type { IMetricOption } from './types';

const metricOptionMap: Record<TMetricType, IMetricOption> = {
  dau: {
    value: 'dau',
    labelKey: 'dbi_metric_dau',
  },
  wau: {
    value: 'wau',
    labelKey: 'dbi_metric_wau',
  },
  mau: {
    value: 'mau',
    labelKey: 'dbi_metric_mau',
  },
  revenue: {
    value: 'revenue',
    labelKey: 'dbi_metric_revenue',
  },
  download: {
    value: 'download',
    labelKey: 'dbi_metric_downloads',
  },
};
/**
 * 根据粒度获取指标选项
 */
export const getMetricOptions = (granularity: IGranularity): IMetricOption[] => {
  const metrics = METRICS_MAP[granularity] || [];
  return metrics.map((metric) => {
    return metricOptionMap[metric];
  });
};

/**
 * 默认选中的指标
 */
export const DEFAULT_METRIC: TMetricType = 'download';
